Mmg.addShortcode(

  /**
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'share',
  '.sc-share',

  /**
   *
   * Shortcode callback
   *
   * The shortcode callback receives the following parameters:
   *
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {

    // Widget Declarations
    const $this = $(el);
    const $copyLinkButton = $this.find(`${selector}__copy-link`);

    /**
     * Initialize the widget
     */
    (function init(){
      $copyLinkButton.tooltip({trigger: 'manual'});
      addEvents();
    })();

    /**
     * Handle UI events
     */
    function addEvents() {
      $copyLinkButton.on('click', copyToClipboard);
    }

    /**
     * Copies URL to clipboard and shows tooltip
     */
    function copyToClipboard(event) {
      event.preventDefault();
      navigator.clipboard.writeText(window.location.href);
      $copyLinkButton.tooltip('show');
      setTimeout(() => {
        $copyLinkButton.tooltip('hide');
      }, 2000);
    }
  }
);
